/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/teacher.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
function TeacherPreparing() {
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '회사 면담', value: 1},
    {title: '사전통화', value: 2},
    {title: '입회원서 확인', value: 3},
    {title: '완료', value: 4}
  ];
  return (
    <main className="com_container p_preparing">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_2">준비중 교사</h2>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">국어</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">영어</label>
                  <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">수학</label>
                  <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">과탐</label>
                  <input type="radio" name="rdo" id="rdo06" className="com_chk circle" />
                  <label htmlFor="rdo06">사탐</label>
                  <input type="radio" name="rdo" id="rdo07" className="com_chk circle" />
                  <label htmlFor="rdo07">수시</label>
                  <input type="radio" name="rdo" id="rdo08" className="com_chk circle" />
                  <label htmlFor="rdo08">논술</label>
                </div>
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="6%" />
                <col width="10%" />
                <col width="6%" />
                <col width="10%" />
                <col width="auto" />
                <col width="auto" />
                <col width="10%" />
                <col width="auto" />
                <col width="auto" />
                <col width="auto" />
              </colgroup>
              <thead>
                <tr>
                  <th>No</th>
                  <th>교사명</th>
                  <th>과목</th>
                  <th>학생</th>
                  <th>
                    첫수업 일&nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>전화번호</th>
                  <th>담임</th>
                  <th>회사면담</th>
                  <th>사전통화</th>
                  <th>입회원서</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td>1</td>
                  <td>
                    <button className="btn_link">김교사103</button>
                  </td>
                  <td>국어</td>
                  <td>
                    <button className="btn_link">홍길동101</button>
                  </td>
                  <td>
                    2023,05,10
                    <br />
                    20:30
                  </td>
                  <td>
                    학 010 - 1234-5786
                    <br />
                    부 010 - 1234-5786
                    <br />모 010 - 1234-5786
                  </td>
                  <td>
                    <button className="btn_link">김담임102</button>
                  </td>
                  <td className="td_point td_date">2023,05,10</td>
                  <td className="td_point td_date">2023,05,10</td>
                  <td className="td_point td_date">2023,05,10</td>
                </tr>
                {[2, 3, 4, 5].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>
                        <button className="btn_link">김교사103</button>
                      </td>
                      <td>수학</td>
                      <td>
                        <button className="btn_link">홍길동101</button>
                      </td>
                      <td>
                        2023,05,10
                        <br />
                        20:30
                      </td>
                      <td>
                        학 010 - 1234-5786
                        <br />
                        부 010 - 1234-5786
                        <br />모 010 - 1234-5786
                      </td>
                      <td>
                        <button className="btn_link">김담임102</button>
                      </td>
                      <td className="td_point td_date">2023,05,10</td>
                      <td className="td_point td_date">2023,05,10</td>
                      <td className="td_point td_date">2023,05,10</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">수업 상세</div>
            <div className="com_board_box">
              <div className="com_info">
                <p className="name">홍길동103</p>
                <p className="date dot">2025, 05, 20 11 : 30</p>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    <span> (고3ㆍ본사) </span>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">연락처</span>
                  <div className="cont">
                    <p className="txt">010-1234-233</p>
                    <p className="txt">
                      <span>부)010-1234-233</span>
                      <span className="dot" />
                      <span>모)010-1234-233</span>
                    </p>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업장소</span>
                  <span className="cont">경기도 수원시</span>
                </div>
                <div className="info">
                  <span className="tit">첫 수업일시</span>
                  <span className="cont">2023.05.10 12:30</span>
                </div>
                <div className="info">
                  <span className="tit">다음 수업일시</span>
                  <span className="cont">2023.05.10 12:30</span>
                </div>
                <div className="info">
                  <span className="tit">교사</span>
                  <span className="cont">
                    <button className="btn_link">김교사302</button>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">
                    <button className="btn_link">김담임302</button>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont">과탐</span>
                </div>
                <div className="info">
                  <span className="tit">수업상세</span>
                  <span className="cont">사회문화,경제,밥과정서</span>
                </div>
                <div className="info">
                  <span className="tit">기수 / 타임</span>
                  <span className="cont">2기 / 2T</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">학생상담 시간</span>
                  <span className="cont">30분</span>
                </div>
                <div className="info">
                  <span className="tit">상담내용</span>
                  <span className="cont">학생이 뭐라고 뭐라고</span>
                </div>
                <div className="info">
                  <span className="tit">학부모 상담 시간</span>
                  <span className="cont">50분</span>
                </div>
                <div className="info">
                  <span className="tit">상담 내용</span>
                  <span className="cont">학부모가 뭐라고 뭐라고</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">학생반응</span>
                  <span className="cont com_blue_txt">매우 긍정</span>
                </div>
                <div className="info">
                  <span className="tit">수업 이해도</span>
                  <span className="cont com_blue_txt">대체로 잘함</span>
                </div>
                <div className="info">
                  <span className="tit">등급 수준</span>
                  <span className="cont com_blue_txt"> 2~3 등급</span>
                </div>
                <div className="info">
                  <span className="tit">학부모 반응</span>
                  <span className="cont com_blue_txt"> 대체로 긍정</span>
                </div>
                <div className="info">
                  <span className="tit">이지 교재</span>
                  <span className="cont">교재 있음</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업진행 가능성</span>
                  <span className="cont com_blue_txt">매우긍정 문제점</span>
                </div>
                <div className="info">
                  <span className="tit">문제점</span>
                  <span className="cont com_blue_txt">
                    학부모 <br />
                    조금 성향이 강한 부분이 있습니다.
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 계획서</span>
                  <span className="cont">수업계획서 파일명 파일명</span>
                  <button className="com_btn xxs btn_down_text">다운로드</button>
                </div>
              </div>
              <div className="board_item">
                <div className="info center">
                  <span className="cont">
                    <span className="check_line">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">면담을 하였습니다.</label>
                    </span>
                  </span>
                  <div className="datepicker">
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  </div>
                </div>
              </div>
              <div className="board_item">
                <div className="info center">
                  <span className="cont">
                    <span className="check_line">
                      <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                      <label htmlFor="chk02">사전통화를 하였습니다.</label>
                    </span>
                  </span>
                  <div className="datepicker">
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  </div>
                </div>
              </div>
              <div className="board_item">
                <div className="info center">
                  <span className="cont">
                    <span className="check_line">
                      <input type="checkbox" name="chk" id="chk03" className="com_chk" />
                      <label htmlFor="chk03">입회 원서를 확인하였습니다.</label>
                    </span>
                  </span>
                </div>
              </div>

              <div className="com_btn_wrap center bottom">
                <button className="com_btn orange s">확인</button>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}
export default TeacherPreparing;
